import * as React from 'react';
import cn from 'classnames';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Header, ModalX } from '../../../BaseComponents';
import { useTheme } from '../../../theme';
import { useIsMobile } from '../../../utils';
const DirectionsDialog = ({ countries, isOpen, onClose, onSelect }) => {
    var _a;
    const { DirectionsDialog: css } = useTheme('LocationAutocomplete');
    const { t } = useTranslation('LocationAutocomplete');
    const isMobile = useIsMobile();
    const [selectedCountry, setSelectedCountry] = useState();
    const showCityList = !isMobile || !!selectedCountry;
    const showCountryList = !isMobile || !selectedCountry;
    const onCountrySelect = (country) => {
        setSelectedCountry(country);
    };
    const clearCountrySelection = () => setSelectedCountry(undefined);
    const onCitySelect = (location) => () => {
        onSelect(location);
        onClose();
    };
    React.useEffect(() => {
        if (!isOpen) {
            return;
        }
        if (isMobile) {
            clearCountrySelection();
        }
        else {
            setSelectedCountry(countries[0]);
        }
    }, [isOpen]);
    return (React.createElement(ModalX, { isOpen: isOpen, size: isMobile ? 'fullscreen' : 'xlarge', onClose: onClose, noPadding: true, enableSwipeToClose: false, classes: {
            root: css.root,
            top_wrapper: css.top_wrapper,
            content: css.content,
            closeButton: css.closeButton
        } },
        React.createElement("div", { className: css.dialog },
            showCountryList && (React.createElement("div", { className: css.countries },
                React.createElement(Header, { className: css.label, showEmptySlots: false, center: React.createElement("div", { className: css.labelText }, t('Pick a country')) }),
                React.createElement("div", { className: css.countries__list }, countries === null || countries === void 0 ? void 0 : countries.map(country => (React.createElement("div", { key: country.label.toString(), "data-country": country.label, className: cn(css.country, {
                        [css.country_active]: country.label === (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.label)
                    }), onClick: () => onCountrySelect(country) }, country.label)))))),
            showCityList && (React.createElement("div", { className: css.cities },
                React.createElement(Header, { className: css.label, showEmptySlots: false, onGoBackward: clearCountrySelection, center: React.createElement("div", { className: css.labelText }, t('Pick a city')) }),
                React.createElement("div", { className: css.cities__list }, (_a = selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.options) === null || _a === void 0 ? void 0 : _a.map(({ value: city, label }, index) => {
                    return (React.createElement("div", { key: index, className: css.city, onClick: onCitySelect(city) },
                        React.createElement("div", null,
                            React.createElement("div", null, label),
                            city.stopPointsCount > 0 && (React.createElement("div", { className: css.stops },
                                city.stopPointsCount,
                                ' ',
                                t('Stop', {
                                    count: city.stopPointsCount
                                })))),
                        React.createElement("span", { className: css.iata }, city.iata)));
                })))))));
};
export default DirectionsDialog;
